import { useSearchParams } from 'react-router';

// Bereichsweiter Filter nach Gebiet und Makler (URL-Parameter gebiet/makler), z. B. im Posteingang.
export function useAreaMaklerParams() {
  const [params] = useSearchParams();
  return { areaId: params.get('gebiet') || undefined, maklerId: params.get('makler') || undefined };
}
